export type SupabaseConfig = {
  url?: string;
  anonKey?: string;
};

export function getSupabaseConfig(): SupabaseConfig {
  const url = import.meta.env.VITE_SUPABASE_URL as string | undefined;
  const anonKey = import.meta.env.VITE_SUPABASE_ANON_KEY as
    | string
    | undefined;
  return { url, anonKey };
}
